// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"06626376","28":"e18d0227","179":"88ab32bc","279":"f98871d5","450":"aa401bbf","452":"db0c5a89","453":"c6a9083d","481":"1fcba80c","515":"c9dbd849","530":"0bc00575","552":"4fe14382","624":"6fcd144c","714":"9e76ec9f","849":"ddcc7716","855":"eb3d6d3d","898":"6cadf741"}[chunkId] + ".chunk.js";
};